import { createVNode as i, mergeProps as p } from "vue";
import l from "../node_modules/@pf-ui/pf-icon-svg/es/asn/OppositeFilled.js";
import s from "../components/PfIcon.js";
const e = (t, o) => {
  const r = {
    ...t,
    ...o.attrs
  };
  return i(s, p(r, {
    icon: l
  }), null);
};
e.displayName = "OppositeFilled";
e.inheritAttrs = !1;
export {
  e as default
};
